import { useEffect } from 'react'

function useEffectAsync(func: () => any, args: any[]) {
  useEffect(() => { func() }, args)
}

export default useEffectAsync
